import { AnyAction } from 'redux'

import { IForm } from 'core-components/classes/models/IForm'

import { IDatabase, IFetchResult, IFormStore } from './Interfaces'

export const getReducer = (
  initialState: IDatabase<any>,
  relations: (id: string) => any,
  getKeyByForm: (id: string) => any,
  SAVE_DATA: string,
  REMOVE_DATA: string,
  REMOVE_QUERIES?: string,
  REMOVE_GROUPS?: string
) => {
  const applyRelations = (
    dataStore: IDatabase<any>,
    rowFrom: IForm,
    dataProviderId: string
  ): string[] => {
    const relation = relations(dataProviderId)
    const changes: string[] = []
    const keyField1 = getKeyByForm(dataProviderId)

    if (relation) {
      for (const i in relation) {
        const store: IFormStore<IForm> = dataStore.forms[i]
        const keyField2 = getKeyByForm(i)

        if (store) {
          const fieldLink = relation[i].fieldLink
          const linkValue = Object.hasOwnProperty.call(rowFrom, fieldLink)
            ? rowFrom[fieldLink]
            : rowFrom[keyField1]

          store.data.forEach((record: any) => {
            if (record[fieldLink] == linkValue) {
              changes.push(i)

              if (rowFrom['DELETED']) {
                record['DELETED'] = true
              } else {
                Object.keys(rowFrom).forEach((syncFieldName: string) => {
                  if (syncFieldName != keyField1 && syncFieldName != keyField2) {
                    record[syncFieldName] = rowFrom[syncFieldName]
                  }
                })
              }
            }
          })
        }
      }
    }

    return changes
  }

  const mergeFn = (
    dataProviderId: any,
    query: string,
    data: IFetchResult<IForm>,
    dataStore: IDatabase<any>
  ) => {
    const currentForm: IForm[] = dataStore.forms[dataProviderId].data || []
    let changes: string[] = []

    data.items.forEach((row, curIndex) => {
      const ind = currentForm.findIndex(
        (curRow) => curRow[getKeyByForm(dataProviderId)] === row[getKeyByForm(dataProviderId)]
      )

      if (ind > -1) {
        data.items.splice(curIndex, 1, Object.assign(currentForm[ind], row))
        changes = applyRelations(dataStore, currentForm[ind], dataProviderId)
      } else {
        currentForm.push(row)
        changes = applyRelations(dataStore, row, dataProviderId)

        if (!query) {
          dataStore.forms[dataProviderId].queries = {}
        }
      }
    })

    changes.push(dataProviderId)
    changes.forEach(
      (change: string) => (dataStore.forms[change].data = dataStore.forms[change].data.slice())
    )

    const queries = dataStore.forms[dataProviderId].queries

    if (query && data && data.items) {
      queries[query] = data
      dataStore.forms[dataProviderId].queries[query] = data
      dataStore.forms[dataProviderId] = {
        ...dataStore.forms[dataProviderId],
        queries,
      }
    }

    return {
      ...dataStore,
      forms: {
        ...dataStore.forms,
      },
    }
  }

  const removeFn = (
    dataProviderId: any,
    key: string,
    dataStore: IDatabase<any>
  ) => {
    let changes: string[] = []
    const currentForm: IForm[] = dataStore.forms[dataProviderId].data || []
    const newForm = currentForm.filter((el) => {
      if (el[getKeyByForm(dataProviderId)] === key) {
        el['DELETED'] = true
        changes = applyRelations(dataStore, el, dataProviderId)
      }

      return el[getKeyByForm(dataProviderId)] !== key
    })

    dataStore.forms[dataProviderId].data = newForm
    dataStore.forms[dataProviderId].queries = {}
    changes.push(dataProviderId)

    changes.forEach((change: string) => {
      dataStore.forms[change].data = dataStore.forms[change].data.slice()
      dataStore.forms[change].queries = {}
    })

    return {
      ...dataStore,
      forms: {
        ...dataStore.forms,
      },
    }
  }

  const removeQueries = (
    dataProviderId: any,
    dataStore: IDatabase<any>
  ) => {
    dataStore.forms[dataProviderId].queries = {}

    return {
      ...dataStore,
      forms: {
        ...dataStore.forms,
      },
    }
  }

  const removeGroups = (
    dataProviderId: any,
    dataStore: IDatabase<any>
  ) => {
    return {
      ...dataStore,
      forms: {
        ...dataStore.forms,
      },
    }
  }

  const reducer = (state: IDatabase<any> = initialState, action: AnyAction) => {
    if (action.type === SAVE_DATA) {
      return mergeFn(action.formId, action.query, action.data, state)
    }

    if (action.type === REMOVE_DATA) {
      return removeFn(action.formId, action.id, state)
    }

    if (REMOVE_QUERIES && action.type === REMOVE_QUERIES) {
      return removeQueries(action.formId, state)
    }

    if (REMOVE_GROUPS && action.type === REMOVE_GROUPS) {
      return removeGroups(action.formId, state)
    }

    return state
  }

  return reducer
}
